import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

import { WarningIcon } from 'components/Icons/WarningIcon'

const Container = styled.div`
  border: 1px solid #ffa800;
  background-color: #fff9d8;
  padding: 11px 8px;
  display: flex;
  align-items: center;
  gap: 0 8px;
`

export const WarningIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
  background-color: #ffa800;
  border-radius: 50%;
`

const Message = styled.span`
  font-size: 14px;
  color: #28265d;
`

interface IWarningNotificationProps {
  children: ReactNode
}

export const WarningNotification = ({ children }: IWarningNotificationProps): ReactElement => {
  return (
    <Container>
      <WarningIconWrapper>
        <WarningIcon />
      </WarningIconWrapper>
      <Message>{children}</Message>
    </Container>
  )
}
